
<template>
  <section class="page-container">
    <router-link :to="'/admin/activityItem/new'"><elvas-button :button="{title: 'Adicionar Novo'}"></elvas-button></router-link>
    <div class="activities" v-if="interestPoints">
      
      <router-link :to="'/admin/activityItem/' + interestPoint.id" class="interest-point-item" v-for="interestPoint in interestPoints" :key="interestPoint.id">
        <div class="zoomable-image image"><img :src="interestPoint.images[0] && interestPoint.images[0].image_url"></div>
        <h2 class="title" v-if="interestPoint.translation">{{interestPoint.translation.name}}</h2>
      </router-link>
    </div>
  </section>
</template>
<script>
import ElvasButton from '../../components/elvas-button.vue'

export default {
  name: 'adminInterestPoints',
  components: {
    ElvasButton
  },
  data() {
    return {
      interestPointsFull: null,
      interestPoints: null,
      filter: 'all'
    }
  },
  async mounted () {
    this.interestPoints = await this.api.get('activity')
    this.interestPointsFull = [...this.interestPoints]
  },
  methods: {
    selectFilter(filter) {
      this.filter = filter
      if (filter === 'all') this.interestPoints = this.interestPointsFull
      else {
        this.interestPoints = this.interestPointsFull.filter(point => point.type === filter)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  background: #f6ede0;
}
h4 {
  font-size: 34px;
  text-transform: uppercase;
  font-weight: bold;
  margin: 20px;
  color:#f6b92f;
}
.elvas-button {
  margin-top: 20px;
  margin-left: auto;
  margin-right: 120px;

  @media (max-width: 1200px){
    margin-right: 100px;
  }

  @media (max-width: 900px){
    margin-right: 70px;
  }

  @media (max-width: 650px){
    margin-right: 50px;
  }

  @media (max-width: 500px){
    margin: 20px auto 0;
  }
}
.activities {
  display: flex;
  flex-wrap: wrap;
  padding: 50px 100px 0 100px;

  @media (max-width: 1200px){
    padding: 50px 80px;
  }

  @media (max-width: 900px){
    padding: 50px 50px;
  }

  @media (max-width: 650px){
    padding: 50px 30px;
  }

  @media (max-width: 450px){
    padding: 50px 8px;
  }
}
.activities a {
  width: calc(100% / 4 - 40px);
  margin: 0 20px;

  @media (max-width: 1200px){
    width: calc(100% / 3 - 40px);
  }

  @media (max-width: 900px){
    width: calc(100% / 2 - 40px);
  }

  @media (max-width: 650px){
    width: calc(100% - 40px);
  }
}
.activities /deep/ .interest-point-item {
    margin-bottom: 40px;
    position: relative;
    & > .image {
      max-height: 200px;
      width: 100%;
      img {
        width: 100%;
      }
    }
    h2 {
      font-weight: bold;
      font-size: 18px;
      line-height: 1.22;
      letter-spacing: -0.4px;
      color: #a79374;
      margin-top: 16px;
    }
    p {
      font-size: 16px;
      line-height: 1.5;
      color: #a79374;
    }
}
</style>